import { Component, OnInit } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Router } from '@angular/router';

@Component({  
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private api: ApiService, private router: Router) { }

  public synchronizing: boolean = false;

  ngOnInit(): void {
  }

  login(username: string, password: string) {

    this.synchronizing = true;
    this.api.login(username, password).subscribe(succeed => {
      this.synchronizing = false;

      if (succeed) this.router.navigateByUrl("/home");
    })
  }
}
